// vms-fit-cards.js: Save my TV badges on product cards, the fit toggle and the count bar. Notes: assets/vms-fit-cards.notes.md
(function () {
  'use strict';
  if (window.VMSFitCards) return;
  var KEY = 'vms:fit-only', pending = false;
  var TAG_WARN = 'Fits your TV, check the weight', COUNT_WARN = ' Check your TV\'s weight.';
  var FITS = { fits: true, fits_rails: true, check_weight: true, size_only: true };

  function only(v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(KEY) === '1';
      if (v) window.sessionStorage.setItem(KEY, '1'); else window.sessionStorage.removeItem(KEY);
    } catch (e) { return false; }
    var d = document.documentElement;
    if (d && d.setAttribute) { if (v) d.setAttribute('data-vms-fit-only', ''); else d.removeAttribute('data-vms-fit-only'); }
    return !!v;
  }
  function parse(s) { try { return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function cell(card) { return (card.closest && card.closest('li')) || card; }

  function context() {
    var S = window.VMSSavedTv, F = window.VMSMountFit, rec = S && S.get ? S.get() : null;
    var tv = rec && F && S.toTv ? S.toTv(rec, F) : null;
    return { S: S, F: F, rec: tv ? rec : null, tv: tv };
  }

  function piece(cls, text, quiet) {
    var s = document.createElement('span');
    s.classList.add(cls);
    s.textContent = text;
    if (quiet) s.setAttribute('aria-hidden', 'true');
    return s;
  }

  function shortBadge(ctx, kind, badge) {
    var B = ctx.F && ctx.F.BADGE;
    if (!badge || kind !== 'fit' || !B || ctx.tv.source !== 'catalog' || badge !== B.fits(ctx.tv.model)) return null;
    return badge === B.fits(null) ? null : B.fits(null);
  }

  function paint(card, ctx) {
    var v = null, slot = card.querySelector('[data-vms-fit-badge]');
    if (ctx.tv) {
      if (card.vmsFitMount === undefined) card.vmsFitMount = parse(card.getAttribute('data-vms-fit-mount'));
      if (card.vmsFitMount) v = ctx.F.verdict(ctx.tv, card.vmsFitMount);
    }
    var kind = v ? v.kind : 'none', warn = !!(v && v.fit === 'check_weight'), hide = !!(slot && v && v.hide);
    var badge = slot && v && v.badge ? (warn && ctx.tv.source === 'catalog' ? TAG_WARN : v.badge) : null, brief = shortBadge(ctx, kind, badge);
    card.setAttribute('data-vms-fit-kind', kind);
    if (warn) card.setAttribute('data-vms-fit-warn', ''); else card.removeAttribute('data-vms-fit-warn');
    card.setAttribute('data-vms-fit-hide', hide ? 'true' : 'false');
    if (slot) {
      slot.textContent = '';
      if (badge) {
        var tag = slot.appendChild(piece('vms-fit-tag', brief ? '' : badge));
        if (brief) {
          var model = String(ctx.tv.model), full = tag.appendChild(piece('vms-fit-row__full', badge.slice(0, badge.length - model.length)));
          full.appendChild(piece('vms-fit-row__model', model));
          tag.appendChild(piece('vms-fit-row__short', brief, true));
        }
      }
      slot.hidden = !badge;
    }
    return { kind: kind, hide: hide, badge: badge, fit: v ? v.fit : null };
  }

  function checkable(tv) { return tv.source !== 'catalog' || tv.state === 'ok'; }

  function countText(ctx, n, warn, hidden, short) {
    var tv = ctx.tv, label = ctx.S.label(ctx.rec), t;
    if (tv.source === 'catalog' && tv.state === 'proprietary') return short ? 'It needs the maker\'s own mount' : 'Your ' + label + ' needs the maker\'s own mount';
    if (tv.source === 'catalog' && tv.state !== 'ok') return short ? 'We do not have its hole pattern' : 'We do not have the hole pattern for your ' + label;
    var who = short ? 'it' : tv.source === 'catalog' ? 'your ' + label : 'your TV (' + label + ')';
    if (tv.source !== 'catalog' && (tv.vesaW == null || tv.vesaH == null)) {
      var scr = 'a ' + tv.sizeIn + ' in screen';
      t = n ? n + (n === 1 ? ' mount here takes ' : ' mounts here take ') + scr : 'None of these mounts takes ' + scr;
    } else if (n) t = n + (n === 1 ? ' mount here fits ' : ' mounts here fit ') + who;
    else t = 'None of these mounts fits ' + who;
    if (hidden) t += ' (' + hidden + ' hidden)';
    return n && warn ? t + '.' + COUNT_WARN : t;
  }

  function dawnCount(hidden) {
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var el = document.getElementById(id), m, a, t;
      if (!el) return;
      if (!el.vmsFitNode || el.firstChild !== el.vmsFitNode || el.textContent !== el.vmsFitText) el.vmsFitOrig = el.textContent;
      t = el.vmsFitOrig;
      m = hidden > 0 ? /^\s*(\d+) (?:of (\d+) (products?)|products?)\s*$/.exec(t) : null;
      a = m ? Number(m[1]) - hidden : -1;
      if (a >= 0) t = m[2] ? a + ' of ' + m[2] + ' ' + m[3] : a + (a === 1 ? ' product' : ' products');
      if (el.textContent !== t) el.textContent = t;
      el.vmsFitNode = t === el.vmsFitOrig ? null : el.firstChild;
      el.vmsFitText = t;
    });
  }

  function boxHome() { var h = null; all(document, '[data-vms-fit-box]').some(function (b) { h = b.querySelector('[data-vms-fit-home]'); return !!h; }); return h; }

  function runScope(scope, ctx) {
    var cards = all(scope, '[data-vms-fit-card]'), n = 0, warn = 0, hideable = 0, on = false;
    cards.forEach(function (c) {
      var r = paint(c, ctx);
      if (r.badge && FITS[r.fit]) { n++; if (r.fit === 'check_weight') warn++; }
      if (r.hide) hideable++;
    });
    var homes = all(scope, '[data-vms-fit-bar]').filter(function (bar) { return bar.getAttribute('data-vms-fit-pages') === '1'; });
    var home = homes.length ? boxHome() : null;
    if (home) homes.unshift(home);
    var can = !!ctx.tv && checkable(ctx.tv) && n > 0 && hideable > 0;
    homes.forEach(function (h) {
      var box = h.querySelector('[data-vms-fit-toggle]'), wrap = h.querySelector('[data-vms-fit-toggle-wrap]');
      if (can && only()) on = true;
      if (box) box.checked = can && only();
      if (wrap) wrap.hidden = !can;
    });
    homes.forEach(function (h) {
      var line = h.querySelector('[data-vms-fit-count]'), text = ctx.tv ? countText(ctx, n, warn, on ? hideable : 0, h.hasAttribute('data-vms-fit-short')) : '';
      if (line && line.textContent !== text) line.textContent = text;
    });
    cards.forEach(function (c) { cell(c).classList.toggle('vms-fit-hidden', on && c.getAttribute('data-vms-fit-hide') === 'true'); });
    if (homes.length) dawnCount(on ? hideable : 0);
    if (scope.setAttribute) scope.setAttribute('data-vms-fit-ready', '');
    return { cards: cards.length, fit: n, warn: warn, hideable: hideable, only: on, box: !!home };
  }

  function paintBox(ctx) {
    all(document, '[data-vms-fit-box]').forEach(function (b) {
      var name = ctx.rec ? ctx.S.label(ctx.rec) : '', was = b.vmsFitName;
      b.vmsFitName = name;
      all(b, '[data-vms-fit-name]').forEach(function (el) { if (el.textContent !== name) el.textContent = name; });
      if (was != null && was !== name) open(b, false);
    });
  }

  function open(b, on) {
    if (on) b.classList.add('is-open'); else b.classList.remove('is-open');
    all(b, '[data-vms-fit-other]').forEach(function (btn) { btn.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }

  function watch(scope) {
    if (scope.vmsFitWatch || typeof MutationObserver === 'undefined') return;
    scope.vmsFitWatch = new MutationObserver(function () { var ctx = context(); paintBox(ctx); runScope(scope, ctx); });
    scope.vmsFitWatch.observe(scope, { childList: true });
  }

  function runAll() {
    pending = false;
    var ctx = context();
    paintBox(ctx);
    return all(document, '[data-vms-fit-scope]').map(function (s) { watch(s); return runScope(s, ctx); });
  }

  document.addEventListener('vms:tv-changed', function (e) {
    var d = (e && e.detail) || {};
    if (d.cause === 'clear' || d.cause === 'signout') only(false);
    if (d.hidden || document.hidden) { pending = true; return; }
    runAll();
  });
  document.addEventListener('visibilitychange', function () { if (pending && !document.hidden) runAll(); });
  document.addEventListener('change', function (e) {
    var t = e && e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-vms-fit-toggle')) return;
    only(!!t.checked);
    var s = t.closest && t.closest('[data-vms-fit-scope]');
    if (s) runScope(s, context()); else runAll();
  });
  document.addEventListener('click', function (e) {
    var t = e && e.target, btn = t && t.closest ? t.closest('[data-vms-fit-other]') : null, b = btn && btn.closest('[data-vms-fit-box]');
    if (!b) return;
    var on = !b.classList.contains('is-open');
    open(b, on);
    var q = on ? b.querySelector('input[name="q"]') : null;
    if (q && q.focus) q.focus();
  });
  document.addEventListener('shopify:section:load', runAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runAll); else runAll();

  window.VMSFitCards = { run: runAll, runScope: runScope, paint: paint, countText: countText, dawnCount: dawnCount, open: open, KEY: KEY, TAG_WARN: TAG_WARN, COUNT_WARN: COUNT_WARN };
})();
